import React from "react";
import { useParams, useHistory } from "react-router-dom";
import { Box, Typography, Button, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import GetKibanaDashboard from "../../components/Common/HelperComponents/KibanaDashboardComponents/GetKibanaDashboard";

const DepartmentDashboard = () => {
  const { departmentName, startDate, endDate, accountNumbers } = useParams();
  const history = useHistory();

  const handleBack = () => {
    history.goBack();
  };

  // Decode the URL parameters
  const decodedDepartmentName = decodeURIComponent(departmentName || "");
  const decodedStartDate = decodeURIComponent(startDate || "");
  const decodedEndDate = decodeURIComponent(endDate || "");
  const decodedAccountNumbers = decodeURIComponent(accountNumbers || "");

  console.log("🔍 DepartmentDashboard: URL Parameters:", {
    departmentName: decodedDepartmentName,
    startDate: decodedStartDate,
    endDate: decodedEndDate,
    accountNumbers: decodedAccountNumbers
  });

  return (
    <Box
      sx={{
        padding: "1.5rem 2rem",
        mb: "3rem",
        backgroundColor: "#F9F9F9",
        minHeight: "100vh",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      }}
    >
             {/* Department Info with Back Button */}
       <Box sx={{ mb: 3 }}>
         <Box
           sx={{
             backgroundColor: "white",
             borderRadius: "8px",
             p: 2,
             border: "1px solid #e2e8f0",
             mb: 3,
             display: "flex",
             justifyContent: "space-between",
             alignItems: "center",
           }}
         >
           <Box>
                           <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: "#1e293b",
                  mb: 1,
                }}
              >
                {decodedDepartmentName}
              </Typography>
             <Typography
               variant="body2"
               sx={{
                 color: "#64748b",
                 fontSize: "0.875rem",
               }}
             >
               Budget Period: {decodedStartDate} to {decodedEndDate}
             </Typography>
           </Box>
           
           <Button
             variant="outlined"
             startIcon={<ArrowBackIcon />}
             onClick={handleBack}
             sx={{
               borderColor: "#d1d5db",
               color: "#374151",
               backgroundColor: "#ffffff",
               fontWeight: 600,
               fontSize: "0.875rem",
               padding: "8px 16px",
               borderRadius: "6px",
               textTransform: "none",
               boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
               "&:hover": {
                 borderColor: "#9ca3af",
                 backgroundColor: "#f9fafb",
                 boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
               },
             }}
           >
             Back
           </Button>
         </Box>
       </Box>

      {/* Kibana Dashboard */}
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          overflow: "hidden",
          boxShadow:
            "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
        }}
      >
        <GetKibanaDashboard
          dashboardKey="Spend Categorization"
          params={{
            departmentName: decodedDepartmentName,
            startDate: decodedStartDate,
            endDate: decodedEndDate,
            accountNumbers: decodedAccountNumbers,
          }}
        />
      </Box>
    </Box>
  );
};

export default DepartmentDashboard;
